import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".fade-in-section {\n  opacity: 0;\n  transform: translateY(25vh);\n  visibility: hidden;\n  transition: opacity 1200ms ease-out, transform 600ms ease-out, visibility 1200ms ease-out;\n  will-change: opacity, transform, visibility;\n}\n\n.fade-in-section.is-visible {\n  opacity: 1;\n  transform: none;\n  visibility: visible;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=OnScrollFadeIn.scss.js.map
